/** @module SiteAdmin/Config/DomainAttributeTable */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/comm",
	"csi/core/ExtendedPath",
	"csi/core/Key",
	"csi/locale",
	"csi/reflection",
	"csi/store/_ClientRequestMixin",
	"csi/store/Nodes",
	"csi/table/Widget",
	"csi/xml",
	"ChangeTracking"
], function(declare, _, comm, ExtendedPath, Key, locale, reflection, _ClientRequestMixin, Nodes, TableWidget, xml, ChangeTracking) {

	var _Nodes = declare([Nodes, _ClientRequestMixin], {
		/** @property {DomainClass} domainClass - domain class owning attributes in store */
		domainClass: null,

		/** @property {string} domainClassUrl - domain class URL used to query for attributes */
		domainClassUrl: null,

		/**
		 * @override
		 * Query for domain attributes and localize name of each attribute
		 */
		_resolveData: function(dfd) {
			const req = comm.getNodeRequest(xml.getUrlPath(this.domainClassUrl, xml.path("DomainAttributes")));

			this._bSuppressRequest = true;

			req.go().then(
				response => {
					const omit = {
						"Code": 1,
						"LocalizedName": 1,
						"Node Name": 1
					};

					const data = response.getResultNodes().filter(node => {
						const id = node.$Name;

						if (omit[id]) {
							return false;
						}

						const type = this.domainClass.getDomainAttributeClass(id) ? this.domainClass.getDomainAttributeClass(id).getType() : null;

						// C8-21206: In Change Log Set-up, for SpecificationDataSheetItem show just 1 attribute Value
						if ((!type || type == ChangeTracking.VALUE_ATTR_CLASS) && ChangeTracking.VALUE_ATTRS.includes(id)) {
							// replace ValueString with Value and discard the rest Value attributes
							// either all Value attributes should be enabled or none
							if (id == "ValueString") {
								xml.nodeSetName(node, locale.typeId(type, ChangeTracking.VALUE_ATTR));
								return true;
							} else {
								return false;
							}
						}
						xml.nodeSetName(node, locale.typeId(type, id));
						return true;
					});

					dfd.resolve(data);
				},
				err => {
					dfd.reject(err);
				}
			);
		}
	});

	return declare(TableWidget, {
		disableCustomViewToolbar: true,
		querySizeFixed: true,
		secondarySortByName: true,

		/**
		 * @override
		 * Reset Values store for tracking column when value changed
		 */
		postAction: function(ac, bKeepDisabled) {
			if (ac && ac.heading) {
				this._setActionButtonsDisabled(false);
				this.onChangeData();
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Disable drag-fill for enabling change tracking
		 */
		_canCopy: function(td) {
			return false;
		},

		/**
		 * @override
		 * Add function to store to augment items with localized names so they can be filtered and sorted
		 */
		_createQueryLevel: function(params, bRoot) {
			const node = this.getViewNode();
			const ql = this.inherited(arguments);

			ql.storeClass = _Nodes;
			ql.storeOptions = {
				domainClass: reflection.getDomainClass(node.$Name),
				domainClassUrl: node.$URL
			};
			return ql;
		},

		/**
		 * @override
		 * Initialize sorting first by Enabled, then by Attribute name
		 */
		_resolveView: function() {
			this.inherited(arguments);

			const rc = this.defView.getPageClass();
			const extendedPath = ExtendedPath.create(rc);
			const key1 = new Key({
				extendedPath,
				id: xml.ATTR_NAME,
			});
			const key2 = new Key({
				extendedPath,
				id: "ChangeTrackingEnabled",
			});

			this.set("sortSettings", [
				{key: key2.typedString, descending: true},
				{key: key1.typedString}
			]);
		}
	});
});